var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { defaults, forEach, head, isArray, isEmpty, reduce } from 'lodash';
import React, { Fragment, PureComponent } from 'react';
import classnames from 'classnames';
import AddButton from './AddButton';
import AssetCategorySelector from './AssetCategorySelector';
import AssetConditionsSelector from './AssetConditionsSelector';
import AssetGroupSelector from './AssetGroupSelector';
import AssetRegisterTreeViewSelector from './AssetRegisterTreeViewSelector';
import ButtonSelector from './ButtonSelector';
import CommunicateSource from './CommunicateSource';
import CommunicationLogType from './CommunicationLogType';
import CommunicationStatus from './CommunicationStatus';
import CommunicationType from './CommunicationType';
import ConfidentialityLevelSelector from './ConfidentialityLevelSelector';
import CustomizeColumn from './CustomizeColumn';
import DateRangePicker from './DateRangePicker';
import styles from './FilterBar.scss';
import GqlStaticTreeSelector from './GqlStaticTreeSelector';
import withFilterHiding from './hocs/withFilterHiding';
import withFilterStore from './hocs/withFilterStore';
import { ApplyFilterContext } from './hooks/useApplyFilter';
import IntakeOrganisationLevelsTreeSelector from './IntakeOrganisationLevelsTreeSelector';
import LearningPlanStatusSelector from './LearningPlanStatusSelector';
import LearningSpaceTasksTypeSelector from './LearningSpaceTasksTypeSelector';
import MultiselectFilter from './MultiselectFilter';
import OrganisationGroupSelector from './OrganisationGroupSelector';
import OrganisationsBeTreeSelector from './OrganisationsBeTreeSelector';
import OrganisationsTreeSelector from './OrganisationsTreeSelector';
import OrganisationStructuresSelector from './OrganisationStructuresSelector';
import OrgGroupPersonEntityTypeSelector from './OrgGroupPersonEntityTypeSelector';
import OrgHolidayCalendarsSelector from './OrgHolidayCalendarsSelector';
import ProgramGroupSelector from './ProgramGroupSelector';
import LibrarySelector from './LibrarySelector';
import ProgramIntakeClassStatusSelector from './ProgramIntakeClassStatusSelector';
import ProgramIntakeEnrolmentStatusSelector from './ProgramIntakeEnrolmentStatusSelector';
import ProgramStructureTreeSelector from './ProgramStructureTreeSelector';
import ProgramStructureLPTreeSelector from './ProgramStructureLPTreeSelector';
import ProgramTreeSelector from './ProgramTreeSelector';
import LPViewSelector from './LPViewSelector';
import ReportCategoryTreeSelector from './ReportCategoryTreeSelector';
import ScheduleProgramSelector from './ScheduleProgramSelector';
import SelectBoxFilter from './SelectBoxFilter';
import StatusSelector from './StatusSelector';
import StatusSelectorWithAll from './StatusSelectorWithAll';
import StatusWithDraftMultiSelector from './StatusWithDraftMultiSelector';
import StatusWithDraftAndActiveMultiSelector from './StatusWithDraftAndActiveMultiSelector';
import BusinessProcessStatusMultiSelector from './BusinessProcessStatusMultiSelector';
import StatusWithDraftSelector from './StatusWithDraftSelector';
import TenantInstitutionTypeSelector from './TenantInstitutionTypeSelector';
import TenantPlatformSelector from './TenantPlatformSelector';
import TreeSortingSelector from './TreeSortingSelector';
import TenantStatusSelector from './TenantStatusSelector';
import ToggleAddon from './ToggleAddon';
import TreeSelector from './TreeSelector';
import YearsSelector from './YearsSelector';
import EContentLibraryResourcesTreeSelector from './EContentLibraryResourcesTreeSelector';
import EContentLibraryResourcesSingleSelector from './EContentLibraryResourcesSingleSelector';
import LanguagesMultiSelector from './LanguagesMultiSelector';
import IntakesListSelector from './IntakesListSelector';
import GroupPeopleBySelector from './GroupPeopleBySelector';
import withPaginationRouting from '../../../data/withPaginationRouting';
import ContentViewSelector from './ContentViewSelector';
import ContentSortingSelector from './ContentSortingSelector';
import PersonEntityRoleSelectorWithAll from './PersonEntityRoleSelectorWithAll';
import ApplyFilterButton from '../ApplyFilterButton';
import ModuleSelector from './ModuleSelector';
import TranslationStatusSelector from './TranslationStatusSelector';
import ApprovalStatusSelector from './ApprovalStatusSelector';
import EContentLogSelector from './EContentLogSelector';
import CurriculumStructureViewSelector from './CurriculumStructureViewSelector';
import TranslationContext from '../../utils/Translations/TranslationContext';
const MOBILE_TABLET_BREAKPOINT = 768;
let FilterBar = class FilterBar extends PureComponent {
    constructor(props) {
        super(props);
        this.screenWidth = typeof window === 'undefined'
            ? MOBILE_TABLET_BREAKPOINT + 1
            : window.innerWidth;
        this.handleResize = () => {
            if (this.screenWidth !== window.innerWidth) {
                this.screenWidth = window.innerWidth;
                this.forceUpdate();
            }
        };
        this.handleChange = ({ name, onChange, mapValue }) => (...values) => {
            const { onFilterChanged } = this.props;
            if (!name || !this.isBatch) {
                return onChange(...values);
            }
            let value = mapValue ? mapValue(...values) : head(values);
            if (name === 'organisationStructureId' && values.length === 1) {
                const preservedValue = localStorage.getItem('organisationId');
                value =
                    preservedValue !== null && preservedValue !== undefined
                        ? Number(localStorage.getItem('organisationId'))
                        : head(values);
            }
            if (onFilterChanged) {
                return this.setState(onFilterChanged({ [name]: value }, name));
            }
            this.setState({ [name]: value });
        };
        this.handleApplyFilters = () => {
            const { onChange } = this.props;
            onChange && onChange({ ...this.state, first: 0 });
        };
        this.modifyGroup = child => child && this.isBatch
            ? React.cloneElement(child, {
                onChange: this.handleChange,
                values: this.state,
                modifyChild: this.modifyChild,
            })
            : child;
        this.getValue = ({ name, value }) => {
            var _a;
            if (this.state.hasOwnProperty(name)) {
                return this.state[name];
            }
            else if ((_a = this.props.values) === null || _a === void 0 ? void 0 : _a.hasOwnProperty(name)) {
                return this.props.values[name];
            }
            return value;
        };
        this.modifyChild = child => child && this.isBatch
            ? React.cloneElement(child, {
                onChange: this.handleChange(child.props),
                value: this.getValue(child.props),
                filter: { ...child.props.filter, ...this.state },
            })
            : child;
        this.handleClickSearchButton = () => {
            const { hasPaginationRouting, setPageNumber } = this.props;
            this.handleApplyFilters();
            hasPaginationRouting && setPageNumber && setPageNumber(1);
        };
        this.handleMouseEnter = () => {
            this.setState({ hovered: true });
        };
        this.handleMouseLeave = () => {
            this.setState({ hovered: false });
        };
        this.renderSearchButton = () => this.isBatch && (<ApplyFilterButton className={classnames(styles.searchButton, {
            'pull-right': this.isDesktopRTL,
        })} onClick={this.handleClickSearchButton}/>);
        this.splitFilters = children => {
            const { filterGroups } = this.props;
            if (isEmpty(filterGroups)) {
                return [isArray(children) ? children : [children]];
            }
            const filterGroupMap = reduce(filterGroups, (acc, v, idx) => {
                v.names.forEach(name => {
                    acc[name] = idx + 1;
                });
                return acc;
            }, {});
            return reduce(children, (acc, child) => {
                if (child) {
                    const idx = filterGroupMap[child.props.name] || 0;
                    acc[idx] = acc[idx] || [];
                    acc[idx].push(child);
                }
                return acc;
            }, []);
        };
        this.handleScrollBottom = () => {
            setTimeout(() => {
                const rightPanel = document.getElementsByClassName('disableScrollbar');
                if (rightPanel[0])
                    rightPanel[0].style.overflow = null;
                if (rightPanel[1])
                    rightPanel[1].style.overflow = null;
            }, 0);
        };
        const { searchName, values } = props;
        this.state = Object.assign({
            hovered: false,
        }, searchName && values && values.hasOwnProperty(searchName)
            ? { [searchName]: values[searchName] }
            : {}, 
        // Share initial state from values for all filter items
        reduce(values, (acc, value, key) => {
            acc[key] = value;
            return acc;
        }, {}));
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { searchName, values, onChange } = nextProps;
        if (!searchName || !values || !onChange) {
            return null;
        }
        const prevSearch = prevState[searchName];
        const nextSearch = values[searchName];
        if (prevSearch !== nextSearch) {
            const newState = {
                ...defaults(prevState, values),
                [searchName]: nextSearch,
            };
            onChange(newState);
            return newState;
        }
        return null;
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }
    componentDidUpdate({ values: valuesPrev = {} }) {
        const { values = {}, searchName } = this.props;
        const propsToIterate = { ...values, ...this.state };
        forEach(propsToIterate, (value, key) => {
            if (key !== searchName && valuesPrev[key] !== values[key]) {
                this.setState({ [key]: values[key] });
            }
        });
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    get isBatch() {
        return !!this.props.onChange;
    }
    get isDesktopRTL() {
        const { isLayoutRTL } = this.context;
        return isLayoutRTL && this.screenWidth > MOBILE_TABLET_BREAKPOINT;
    }
    get children() {
        const { children } = this.props;
        if (!this.isBatch) {
            return children;
        }
        if (children && typeof children === 'function') {
            const child = children({
                ...this.props.values,
                ...this.state,
            });
            return child.type === Fragment ? child.props.children : child;
        }
        return children;
    }
    render() {
        const groups = this.splitFilters(this.children);
        const { isVisible } = this.props;
        const { direction, isLayoutRTL } = this.context;
        return (<div className={classnames('navbar navbar-default navbar-xs navbar-component', { [styles.hidden]: !isVisible })} data-layout-direction={direction} dir={direction} onClick={this.handleScrollBottom}>
        <div className={classnames('navbar-collapse collapse in', styles.navbarAdjustment, {
            [styles.navbarAdjustmentRtl]: this.isDesktopRTL || isLayoutRTL,
        })}>
          <ApplyFilterContext.Provider value={{ applyFilters: this.handleApplyFilters }}>
            {groups.map((filters, idx) => {
            const isLastGroup = idx === groups.length - 1;
            const key = filters
                .filter(f => !!f)
                .map(({ props: { name } }) => name)
                .join('-');
            return (<ul key={key} className={classnames('nav navbar-nav', {
                'pull-right': this.isDesktopRTL,
            })}>
                  {React.Children.map(filters, child => {
                var _a;
                if (!child) {
                    return null;
                }
                if (child.type.name === 'ToggleAddon') {
                    return null;
                }
                return (<li key={(_a = child.props) === null || _a === void 0 ? void 0 : _a.name} className={classnames(styles.filterBarItem, {
                    'pull-right': this.isDesktopRTL,
                })}>
                        {this.modifyChild(child)}
                      </li>);
            })}
                  {isLastGroup && this.renderSearchButton()}
                </ul>);
        })}
          </ApplyFilterContext.Provider>
        </div>
      </div>);
    }
};
FilterBar.defaultProps = {
    onChange: undefined,
    searchName: undefined,
    values: {},
    filterGroups: [],
    hasPaginationRouting: false,
};
FilterBar.contextType = TranslationContext;
FilterBar.AddButton = AddButton;
FilterBar.SelectBoxFilter = SelectBoxFilter;
FilterBar.Multiselect = MultiselectFilter;
FilterBar.ButtonSelector = ButtonSelector;
FilterBar.StatusSelector = StatusSelector;
FilterBar.StatusSelectorWithAll = StatusSelectorWithAll;
FilterBar.PersonEntityRoleSelectorWithAll = PersonEntityRoleSelectorWithAll;
FilterBar.TenantStatusSelector = TenantStatusSelector;
FilterBar.LearningPlanStatusSelector = LearningPlanStatusSelector;
FilterBar.TenantPlatformSelector = TenantPlatformSelector;
FilterBar.TreeSortingSelector = TreeSortingSelector;
FilterBar.TenantInstitutionTypeSelector = TenantInstitutionTypeSelector;
FilterBar.TreeSelector = TreeSelector;
FilterBar.GqlStaticTreeSelector = GqlStaticTreeSelector;
FilterBar.DateRangePicker = DateRangePicker;
FilterBar.CustomizeColumn = CustomizeColumn;
FilterBar.ToggleAddon = ToggleAddon;
FilterBar.ConfidentialityLevelSelector = ConfidentialityLevelSelector;
FilterBar.ReportCategoryTreeSelector = ReportCategoryTreeSelector;
FilterBar.OrganisationGroupSelector = OrganisationGroupSelector;
FilterBar.OrgGroupPersonEntityTypeSelector = OrgGroupPersonEntityTypeSelector;
FilterBar.OrganisationStructuresSelector = OrganisationStructuresSelector;
FilterBar.ProgramTreeSelector = ProgramTreeSelector;
FilterBar.LPViewSelector = LPViewSelector;
FilterBar.ProgramIntakeEnrolmentStatusSelector = ProgramIntakeEnrolmentStatusSelector;
FilterBar.ProgramIntakeClassStatusSelector = ProgramIntakeClassStatusSelector;
FilterBar.OrganisationsTreeSelector = OrganisationsTreeSelector;
FilterBar.OrganisationsBeTreeSelector = OrganisationsBeTreeSelector;
FilterBar.ProgramStructureTreeSelector = ProgramStructureTreeSelector;
FilterBar.ProgramStructureLPTreeSelector = ProgramStructureLPTreeSelector;
FilterBar.IntakeOrganisationLevelsTreeSelector = IntakeOrganisationLevelsTreeSelector;
FilterBar.LearningSpaceTasksTypeSelector = LearningSpaceTasksTypeSelector;
FilterBar.StatusWithDraftSelector = StatusWithDraftSelector;
FilterBar.StatusWithDraftMultiSelector = StatusWithDraftMultiSelector;
FilterBar.StatusWithDraftAndActiveMultiSelector = StatusWithDraftAndActiveMultiSelector;
FilterBar.BusinessProcessStatusMultiSelector = BusinessProcessStatusMultiSelector;
FilterBar.YearsSelector = YearsSelector;
FilterBar.OrgHolidayCalendarsSelector = OrgHolidayCalendarsSelector;
FilterBar.AssetConditionsSelector = AssetConditionsSelector;
FilterBar.AssetRegisterTreeViewSelector = AssetRegisterTreeViewSelector;
FilterBar.AssetGroupSelector = AssetGroupSelector;
FilterBar.AssetCategorySelector = AssetCategorySelector;
FilterBar.ScheduleProgramSelector = ScheduleProgramSelector;
FilterBar.ProgramGroupSelector = ProgramGroupSelector;
FilterBar.LibrarySelector = LibrarySelector;
FilterBar.CommunicateSource = CommunicateSource;
FilterBar.CommunicationType = CommunicationType;
FilterBar.CommunicationStatus = CommunicationStatus;
FilterBar.CommunicationLogType = CommunicationLogType;
FilterBar.EContentLibraryResourcesTreeSelector = EContentLibraryResourcesTreeSelector;
FilterBar.EContentLibraryResourcesSingleSelector = EContentLibraryResourcesSingleSelector;
FilterBar.LanguagesMultiSelector = LanguagesMultiSelector;
FilterBar.IntakesListSelector = IntakesListSelector;
FilterBar.GroupPeopleBySelector = GroupPeopleBySelector;
FilterBar.ContentViewSelector = ContentViewSelector;
FilterBar.ContentSortingSelector = ContentSortingSelector;
FilterBar.ModuleSelector = ModuleSelector;
FilterBar.TranslationStatusSelector = TranslationStatusSelector;
FilterBar.ApprovalStatusSelector = ApprovalStatusSelector;
FilterBar.EContentLogSelector = EContentLogSelector;
FilterBar.CurriculumStructureViewSelector = CurriculumStructureViewSelector;
FilterBar = __decorate([
    withFilterStore,
    withFilterHiding,
    withPaginationRouting
], FilterBar);
export default FilterBar;
